import { z } from "zod";
import { EMP, NAME, PROJECT_CODE, ROLE, TEAM } from "./consts";

export const schema = z.object({
  [NAME]: z.string().min(1, "This field is required"),
  [PROJECT_CODE]: z.string().min(1, "This field is required"),
  [TEAM]: z
    .object({
      [ROLE]: z.string().optional(),
      [EMP]: z.string().optional(),
    })
    .array()
    .optional(),
});

export type formValues = z.infer<typeof schema>;
